// extracted by mini-css-extract-plugin
export default {"disclaimerWrapper":"styles_disclaimerWrapper__1Apdt","disclaimerTitle":"styles_disclaimerTitle__nhyCi","disclaimerMsg":"styles_disclaimerMsg__nSDmh","spin":"styles_spin__tMfLM"};